"use client";

import { LazyMotion, domAnimation } from "framer-motion";

/**
 * Loads only framer-motion's `domAnimation` feature set (animations, variants,
 * exit, hover/tap/focus gestures) once for the whole app, so components use the
 * lightweight `m` component instead of the full `motion` component. No `drag` or
 * `layout` features are used anywhere, so `domAnimation` (not `domMax`) is enough.
 */
export default function MotionProvider({ children }: { children: React.ReactNode }) {
  return <LazyMotion features={domAnimation}>{children}</LazyMotion>;
}
